/**
 * 研究生工作模块
 *
 * 二级菜单：
 * - 组会面板（/graduate/meeting）：组会倒计时 / 任务汇总 / 组会小贴纸 / 历史组会
 * - 工作任务（/graduate/tasks）：Trello 风格任务面板
 * - 报销管理（/graduate/reimbursement）：报销单录入 / 状态流转 / 图床附件
 * - 科研英语学习（/graduate/english）：艾宾浩斯背单词 + 词库浏览（/graduate/english/words）
 */

import type { WorkbenchModule } from '../types'

export const graduateModule: WorkbenchModule = {
  meta: {
    name: 'graduate',
    title: '研究生工作',
    description: '组会面板与工作任务管理，提升科研工作效率',
    version: '0.1.0'
  },
  routes: [
    {
      path: '/graduate',
      name: 'graduate',
      redirect: '/graduate/meeting'
    },
    {
      path: '/graduate/meeting',
      name: 'graduate-meeting',
      component: () => import('./views/MeetingPanelView.vue'),
      meta: { title: '组会面板' }
    },
    {
      path: '/graduate/meeting/records/:id',
      name: 'graduate-meeting-record-detail',
      component: () => import('./views/MeetingRecordDetailView.vue'),
      meta: { title: '组会记录详情' }
    },
    {
      path: '/graduate/tasks',
      name: 'graduate-tasks',
      component: () => import('./views/WorkTasksView.vue'),
      meta: { title: '工作任务' }
    },
    {
      path: '/graduate/reimbursement',
      name: 'graduate-reimbursement',
      component: () => import('./views/ReimbursementView.vue'),
      meta: { title: '报销管理' }
    },
    {
      path: '/graduate/english',
      name: 'graduate-english',
      component: () => import('./views/EnglishLearningView.vue'),
      meta: { title: '科研英语学习' }
    },
    {
      path: '/graduate/english/words',
      name: 'graduate-english-words',
      component: () => import('./views/EnglishWordsView.vue'),
      meta: { title: '所有单词' }
    }
  ],
  menuItem: {
    id: 'graduate',
    label: '研究生工作',
    path: '/graduate/meeting',
    icon: 'graduation-cap',
    order: 20
  }
}
